import { styled } from '@mui/material/styles';

const StyledLabel = styled('div')`
  display: flex;
  align-items: center;
  padding: 1rem;
  border: 1px solid lightgrey;
  border-radius: var(--mui-shape-borderRadius);
`;

export default StyledLabel;
